import {Service} from "@/services/superclasses/service";
import {Article} from "@/interfaces/article";

const api = window.contextPath + '/rest/generated-stories';

export class GeneratedStoryService extends Service {

    constructor() {
        super()
    }

    public load = async (args: {
        vatin: string,
        first?: number,
        max?: number
    }): Promise<Article[]> => {
        return this.data(await this.get<Article[]>(api,
            {
                params: args
            }))
    }
}

export const generatedStoryService = new GeneratedStoryService()
